import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AuthProvider } from '@/auth/AuthProvider';
import { Authenticator } from '@aws-amplify/ui-react';
import { configureAmplify } from '@/config/amplifyConfig';
import './App.css';
import '@aws-amplify/ui-react/styles.css';
import { MainContainerLayout } from './Layouts';
import BilletLogo from '@/components/BilletLogo';
import { theme } from './theme/theme';

configureAmplify();

const App: React.FC = () => (
  <Authenticator
    // hideSignUp={true}
    loginMechanisms={[ 'username', 'email']}
    signUpAttributes={['name', 'email', 'phone_number']}
    components={{
      SignIn: {
        Header: () => <BilletLogo />
      },
      SignUp: {
        Header: () => <BilletLogo />
      }
    }
    }>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter>
          <Switch>
            <Route path="/" render={() => <MainContainerLayout />} />
          </Switch>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </Authenticator>
);

export default App;
